import { render, staticRenderFns } from "./MyCoursesSessionsDesktop.vue?vue&type=template&id=1327be66&scoped=true"
import script from "./MyCoursesSessionsDesktop.vue?vue&type=script&lang=js"
export * from "./MyCoursesSessionsDesktop.vue?vue&type=script&lang=js"
import style0 from "./MyCoursesSessionsDesktop.vue?vue&type=style&index=0&id=1327be66&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1327be66",
  null
  
)

export default component.exports